// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".credit[data-v-5eb659c3] {\n  min-height: 20px;\n}\n.credit-box[data-v-5eb659c3] {\n  margin: 0;\n  color: #b8b8b8;\n  font-size: 1rem;\n  text-align: center;\n  white-space: normal;\n}\n.amazon-af-link[data-v-5eb659c3] {\n  width: 88px;\n  height: 20px;\n  margin: 0 auto;\n  border: 1px solid #757de0;\n  border-radius: 4px;\n  font-size: 1.1rem;\n  font-weight: bold;\n  text-align: center;\n  line-height: 18px;\n  box-sizing: border-box;\n}", ""]);
// Exports
module.exports = exports;
